export default "__VITE_ASSET__DWuU11Lz__"